export default "__VITE_ASSET__T$QoNJLS__"